import ModalPage from "./features/modal/ModalPage";
import UsersList from "./features/users/UsersList";

function App() {
  return (
    <section className="my-10">
      <UsersList />
      <ModalPage />
    </section>
  );
}

export default App;
